import { render, staticRenderFns } from "./UserPositTree.vue?vue&type=template&id=4c38b207&scoped=true&"
import script from "./UserPositTree.vue?vue&type=script&lang=js&"
export * from "./UserPositTree.vue?vue&type=script&lang=js&"
import style0 from "./UserPositTree.vue?vue&type=style&index=0&id=4c38b207&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c38b207",
  null
  
)

export default component.exports